import { z } from "zod/mini";
import { en } from "zod/locales";

/**
 * Validação com `zod/mini`: manifestos e `config.json` são conferidos no boot de toda tela,
 * inclusive a landing, e a versão mini é uma fração do tamanho do zod completo. A mini vem
 * sem mensagens; `safeParse(valor, parseOptions)` usa as do zod em inglês
 * ("expected string, received undefined"). As mensagens dos schemas continuam valendo.
 *
 * Por parse e não com `z.config`: este pacote é `sideEffects: false`, e o bundler descartaria
 * a configuração global.
 */
export const parseOptions = { error: en().localeError };

export { z };
